'use client';
import { useEffect } from 'react';
import type { NetworkType } from '../../../../../auth/nocode/types';
import useNetworkContext from '../../../../hooks/useUserContext/useNetworkContext';
import { useGetGlobalAppStateStoreState } from '../../../../stores/app/GlobalAppStateStore';
import { useSetDeviceContext } from './helperHooks/useSetDeviceContext';

export function useInitialiseNetworkStatus() {
  const { isOffline, networkType, isLoading } = useNetworkContext();
  const { getGlobalAppStateStoreState } = useGetGlobalAppStateStoreState();
  const { setDeviceContext } = useSetDeviceContext();

  useEffect(() => {
    const currentNetwork = getGlobalAppStateStoreState().deviceContext.network;

    if (
      isLoading ||
      (currentNetwork?.isOffline === isOffline && currentNetwork?.networkType === networkType)
    ) {
      return;
    }

    // Set network in nocode deviceContext
    setDeviceContext({ network: { isOffline, networkType: networkType as NetworkType } });
  }, [isOffline, networkType, isLoading, getGlobalAppStateStoreState, setDeviceContext]);
}
